var cloneDeep = require("lodash.clonedeep");

export class VOHelper {

    /**
     * Clones a value object.
     *
     * ATTENTION: for complex data types (e.g. Array), only the reference is copied!
     */
    public static clone(vo: any): any {
        if (vo === null || vo === undefined) {
            return;
        }

        return cloneDeep(vo);
    }

    public static areEqual(vo1: any, vo2: any): boolean {
        if ((vo1 == null) || (vo2 == null)) return false;

        return false;
    }
}
